
angular.module('qkr').filter('isCategoryId', () => function(input, cat) {
        if (typeof cat === 'undefined' || cat == '-1' || cat == null) {
            return input;
        } else {
            const out = [];
            for (let a = 0; a < input.length; a++) {
                if (typeof (input[a].category !== 'undefined') && input[a].category.id == cat) {
                    out.push(input[a]);
                }
            }
            return out;
        }
    });



// WEBPACK FOOTER //
// ./src/filters/category.js